'use strict';

module.exports = function mergeOptions(defaults, options) {
    options = options || {};

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, {});
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/parse5/lib/common/merge_options.js
// module id = 1006
// module chunks = 0